import { render, staticRenderFns } from "./ReportsQS.vue?vue&type=template&id=b649bbee&scoped=true"
import script from "./ReportsQS.vue?vue&type=script&lang=ts"
export * from "./ReportsQS.vue?vue&type=script&lang=ts"
import style0 from "./ReportsQS.vue?vue&type=style&index=0&id=b649bbee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b649bbee",
  null
  
)

export default component.exports